// extracted by mini-css-extract-plugin
export default {"gauge-label":"components-parity-charts-gauge-module__gauge-label","tooltip-widget":"components-parity-charts-gauge-module__tooltip-widget"};